export default "__VITE_ASSET__rEnOZlcY__"